export default __webpack_public_path__ + "static/media/Startup Visa - Overview.e1f11712.jpg";